import React, { useState } from 'react';
import {
  Grid,
  TextField
} from '@material-ui/core';
import ColorPickerDialog from './pickers/ColorPickerDialog';


const ColorSelectorGrid = ({
  name,
  label,
  value,
  onChange,
  InputProps = {},
  classes = ''
}) => {
  const [showPicker, setShowPicker] = useState(false);

  return (
    <Grid container spacing={3} className="ml-2 mb-5 items-center">
      <Grid item xs={12} md={3}>
        {label}
      </Grid>
      <Grid item xs={12} md={8} lg={6} className="text-right flex relative">
        <TextField
          variant="outlined"
          color="primary"
          fullWidth
          className={classes}
          name={name}
          label={label}
          value={value}
          InputProps={InputProps}
          onChange={(color) => onChange(color)}
          onClick={() => setShowPicker(true)}
        />
        {showPicker && (
          <ColorPickerDialog
            value={value}
            onClick={() => {
              setShowPicker(false);
              onChange(value);
            }}
            onChange={(color) => {
              onChange(color);
            }}
          />
        )}

        <div
          className="w-full max-w-90 h-40 border-radius-4 border-1-grey ml-4"
          style={{backgroundColor: `${value}`}}
        />
      </Grid>
    </Grid>
  );
};

export default ColorSelectorGrid;
